import { FileResponse } from "../api";
export async function downloadFileResponse(response: FileResponse) {
  const url = URL.createObjectURL(response.data);
  const anchor: HTMLAnchorElement = document.createElement("a");
  anchor.download = response.fileName;
  anchor.href = url;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url));
}
